import React, { useState, useRef, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import propTypes from 'prop-types'

import 'react-datepicker/dist/react-datepicker.css';
import {  CalendarIcon } from '../../../theme/icons';
import { Buttons } from '../Buttons';

export const DateRangePicker = React.memo(({ updateFromToDates, selectsRange, monthsShown, minDate, dateToggele }) => {
    const [isOpendatePicker, setDatePicker] = useState(false)
    const [selectedDates, setSelectedDates] = useState([]);

    const ref = useRef(null);

    const handleDateChange = (date, e) => {

        e.preventDefault();
        e.persist();

        if (selectsRange) {
            setSelectedDates(date)
            const filteredDates = date?.length && date?.filter(date => date !== null);
            if (filteredDates?.length === 2) {
                updateFromToDates(date)
                setDatePicker(false)
            }
        } else {
            setSelectedDates([date]);
            updateFromToDates(date)
            setDatePicker(false)
        }
    };


    const renderDates = (selectedDates) => {
        return (selectedDates?.length && selectedDates?.filter(date=>date)?.map(date => moment(date).format('DD/MM/YYYY')).join('  to  ')) || ""
    }


    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setDatePicker(false);
                !selectedDates?.length ?  updateFromToDates('clearDate') : updateFromToDates(selectedDates) ;
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
        // eslint-disable-next-line
    }, [ref,selectedDates?.length]);

    useEffect(() => {
        const filteredDates = selectedDates?.length && selectedDates?.filter(date => date !== null);
        if (dateToggele && filteredDates?.length === 2) {
            setSelectedDates([])
        }
    }, [dateToggele, selectedDates])



    return (
        <>
            <span role="button"
                className="flex justify-between items-center w-full rounded-md border border-secondary-300 hover:border-secondary-500 px-2 py-1 transition-all duration-300" onClick={() => setDatePicker(!isOpendatePicker)}>
                <span className="text-xs text-secondary-300">
                    {selectedDates?.length ? renderDates(selectedDates) : selectsRange ? 'Click here to choose from and to date' : 'Click here to choose from date'}
                </span>
                {selectedDates?.length ?
                <Buttons onClick={()=>setSelectedDates([])} text="" className="p-0" variant="tertiary" icon={<CalendarIcon />} />

                 :   <Buttons onClick={()=>setSelectedDates([])} text="" className="p-0" variant="tertiary" icon={<CalendarIcon />} />
                }

            </span>
            {isOpendatePicker && <div ref={ref} className="multiple-date-picker relative">
                <DatePicker
                    isOpen={false}
                    selected={selectedDates?.length && selectedDates[0]}
                    onChange={handleDateChange}
                    inline={true}
                    minDate={minDate}
                    startDate={selectedDates?.length && selectedDates[0]}
                    endDate={selectedDates?.length && selectedDates[1]}
                    monthsShown={monthsShown}
                    selectsRange={selectsRange}
                    dateFormat={'dd/MM/yyyy'}
                    isClearable={true}
                    shouldCloseOnSelect={false}
                />
            </div>}
        </>
    );
});

DateRangePicker.propTypes = {
    updateFromToDates: propTypes.bool,
    selectsRange: propTypes.bool,
    monthsShown: propTypes.number,
    minDate: propTypes.instanceOf(Date)
}
DateRangePicker.defaultProps = {
    updateFromToDates: () => { },
    selectsRange: false,
    monthsShown: 1,
    minDate: ""
}